import React, {Component} from 'react';
import {Button, Breadcrumb, Table, Dimmer, Loader} from 'semantic-ui-react';
import {Link} from 'react-router-dom';
import {Helmet} from "react-helmet";

import CustomDivider from '../../components/extras/CustomDivider';
import BranchOfficeData from "../../data/BranchOfficeData";
import BranchOfficeDialog from "../../components/settings/BranchOfficeDialog";
import MainToolbar from "../../components/extras/MainToolbar";
import NoData from "../../components/extras/NoData";
import AlertUpgrade from "../../components/extras/AlertUpgrade";
import CheckPermission from "../../components/extras/CheckPermission";
import localDB from "../../data/localDB";

class Branchs extends Component {

    constructor() {
        super();

        this.state = {
            branchs: [],
            loading: true,
            header: ['Sucursal', 'Dirección', 'Teléfono', 'Acciones']
        };
        this.handleOpenDialog = this.handleOpenDialog.bind(this);
    }

    openDialog = () => {
        if (!localDB.checkPlanAccessExclude('branchs_add') && this.state.branchs.length < localDB.get('plan_access').branch_officess) {
            this.refs.dialog.updateLabels(null);
            this.refs.dialog.handleOpen();
        } else {
            this.refs.alert_upgrade.open();
        }
    };

    componentDidMount() {
        this.initialFetch();
    }

    async initialFetch() {
        const branchs = await BranchOfficeData.listAdmin();
        this.setState({branchs, loading: false});
    }

    handleOpenDialog(branch, index) {
        this.refs.dialog.updateLabels(this.state.branchs[index], index);
        this.refs.dialog.handleOpen(index);
    };

    updateData = (res, index) => {
        let branchs = this.state.branchs.slice();
        branchs[index] = res;
        this.setState({branchs});
    };

    addData = (res) => {
        let branchs = this.state.branchs.slice();
        branchs.push(res);
        this.setState({branchs});
    };

    render() {
        let rows = this.state.branchs.length > 0 ? this.state.branchs.map(function (branch, index) {
            return (
                <Table.Row key={branch.id}>
                    <Table.Cell>{branch.name}</Table.Cell>
                    <Table.Cell>{branch.address}</Table.Cell>
                    <Table.Cell>{branch.phone}</Table.Cell>
                    <Table.Cell>
                        <Button.Group basic size='small'>
                            <Button icon='pencil' onClick={() => this.handleOpenDialog(branch, index)}/>
                        </Button.Group>
                    </Table.Cell>
                </Table.Row>
            )
        }, this) : <NoData colSpan={4}/>;

        let header = this.state.header.map(function (header, i) {
            return (
                <Table.HeaderCell key={i}>
                    {header}
                </Table.HeaderCell>
            )
        }, this);

        let table = <Table celled>
            <Table.Header>
                <Table.Row>
                    <Table.HeaderCell colSpan='4'>
                        <MainToolbar title="Sucursales" name="Sucursal" ref="toolbar" icon="map marker alternate" btnAdd={true}
                                     callbackAdd={this.openDialog} callbackSearch={this.handleSearch}/>
                    </Table.HeaderCell>
                </Table.Row>
            </Table.Header>
            <Table.Header>
                <Table.Row>
                    {header}
                </Table.Row>
            </Table.Header>
            <Table.Body>
                {rows}
            </Table.Body>
        </Table>;

        const progress = <Dimmer.Dimmable><Dimmer active inverted style={{background:'transparent'}}><Loader inline='centered'>Cargando</Loader></Dimmer></Dimmer.Dimmable>;


        return (
            <div>
                <Helmet>
                    <title>Sucursales | Configuraciones - Quipuu</title>
                </Helmet>
                <Breadcrumb>
                    <Breadcrumb.Section as={Link} to='/settings'>Configuraciones</Breadcrumb.Section>
                    <Breadcrumb.Divider/>
                    <Breadcrumb.Section active>Sucursales</Breadcrumb.Section>
                </Breadcrumb>
                <CustomDivider/>
                {this.state.loading ? progress : null}
                {this.state.loading ? null : table}
                <BranchOfficeDialog
                    ref="dialog"
                    title="Sucursal"
                    callbackAddData={this.addData}
                    callbackUpdateData={this.updateData}
                />
                <AlertUpgrade ref='alert_upgrade'/>
                <CheckPermission access='settings__branchs'/>
            </div>
        );
    }
}

export default Branchs;


// WEBPACK FOOTER //
// ./src/containers/settings/Branchs.js